export class Disposer {
    constructor(disposer, option) {
        this.disposed = false;
        this.externalyDisposed = () => false;
        if (option) {
            if (option.externalyDisposed) {
                this.externalyDisposed = option.externalyDisposed;
            }
        }
        this.disposer = disposer;
    }
    dispose() {
        if (this.disposed) {
            return;
        }
        this.disposed = true;
        if (this.externalyDisposed()) {
            return;
        }
        this.disposer();
    }
}
//# sourceMappingURL=disposer.js.map